import React from 'react';

const AffiliateDisclosure = () => {
  return (
    <div className="page-container">
      <h1>Affiliate Disclosure</h1>
      <p>Last updated: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <p>
        Transparency is very important to us at <strong>UpDeals</strong> (https://updeals.in).
        In accordance with the Federal Trade Commission (FTC) guidelines, the Advertising
        Standards Council of India (ASCI), and relevant international guidelines, please assume
        that all links on UpDeals leading to third-party retail stores are affiliate links.
      </p>

      <h2>What Are Affiliate Links?</h2>
      <p>
        When you click on certain outbound links to retailers (such as Amazon, Flipkart, Myntra,
        Ajio, Meesho, Croma, etc.) and complete a qualifying purchase, UpDeals may earn an affiliate
        commission or referral credit from the merchant.
      </p>

      <h2>Does This Cost You Anything Extra?</h2>
      <p>
        <strong>No.</strong> Clicking an affiliate link will never increase the price you pay for any
        product or service. In fact, many deals posted on UpDeals feature exclusive discount codes,
        cashback offers, and lightning deals that help you save money.
      </p>

      <h2>Our Editorial & Deal-Posting Integrity</h2>
      <p>
        Our deal hunters and automation tools curate offers based strictly on consumer value, discount
        magnitude, and price drops. We do not accept payment to promote inferior products. Our primary
        mission is to help shoppers save money on authentic products from established e-commerce platforms.
      </p>

      <h2>Questions or Inquiries</h2>
      <p>
        If you have any questions regarding our affiliate relationships, feel free to contact us at{' '}
        <a href="mailto:support@updeals.in">support@updeals.in</a> or through our official Telegram community.
      </p>
    </div>
  );
};

export default AffiliateDisclosure;
